import React from 'react';
import {
  Headphones, Home, Search, Library, ListMusic, Mic2, MessageCircle, Shield,
  RefreshCw, Plus, Music2, Heart, LogOut, X
} from 'lucide-react';
import { API_BASE } from '../api';
import ThemeSwitcher from './ThemeSwitcher';

function SidebarItem({ icon, label, active = false, onClick }) {
  return (
    <div className={`sidebar-item ${active ? 'active' : ''}`} onClick={onClick}>
      <span>{icon}</span>
      <span>{label}</span>
    </div>
  );
}

export default function Sidebar({
  activeView, setActiveView, setSelectedArtist,
  playlists, fetchPlaylists, token, username, isAdmin,
  handleLogout, songs, refreshSongs, theme, setTheme,
  fetchPlaylistSongs, activePlaylist
}) {
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <span><Headphones /></span> Min Media
      </div>
      <nav className="nav-group">
        <SidebarItem icon={<Home />} label="Hem" active={activeView === 'home'} onClick={() => { setActiveView('home'); setSelectedArtist(null); localStorage.setItem('nas-view', 'home'); }} />
        <SidebarItem icon={<Search />} label="Sök" active={activeView === 'search'} onClick={() => { setActiveView('search'); setSelectedArtist(null); localStorage.setItem('nas-view', 'search'); }} />
        <SidebarItem icon={<Library />} label="Ditt bibliotek" active={activeView === 'library'} onClick={() => { setActiveView('library'); setSelectedArtist(null); localStorage.setItem('nas-view', 'library'); }} />
        <SidebarItem icon={<ListMusic />} label="Alla låtar" active={activeView === 'all-songs'} onClick={() => { setActiveView('all-songs'); setSelectedArtist(null); localStorage.setItem('nas-view', 'all-songs'); }} />
        <SidebarItem icon={<Mic2 />} label="Artister" active={activeView === 'artists'} onClick={() => { setActiveView('artists'); setSelectedArtist(null); localStorage.setItem('nas-view', 'artists'); }} />
        <SidebarItem icon={<MessageCircle />} label="Chatt" active={activeView === 'chat'} onClick={() => { setActiveView('chat'); setSelectedArtist(null); localStorage.setItem('nas-view', 'chat'); }} />
        {isAdmin && <SidebarItem icon={<Shield />} label="Admin" active={activeView === 'admin'} onClick={() => { setActiveView('admin'); setSelectedArtist(null); localStorage.setItem('nas-view', 'admin'); }} />}
      </nav>
      <div className="playlist-section">
        <div className="section-title">Library</div>
        <SidebarItem icon={<RefreshCw />} label="Uppdatera musik" onClick={async () => {
          const currentSongsCount = songs.length;
          await refreshSongs();
          if (songs.length !== currentSongsCount) alert(`Musik uppdaterad! Hittade nu ${songs.length} låtar.`);
          else alert('Ingen ny musik hittades.');
        }} />
        <div className="section-title" style={{ marginTop: '12px' }}>Playlists</div>
        <SidebarItem icon={<Plus />} label="Skapa spellista" onClick={async () => {
          const name = prompt("Namn på spellista:");
          if (name) {
            await fetch(`${API_BASE}/api/playlists`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
              body: JSON.stringify({ name })
            });
            fetchPlaylists();
          }
        }} />
        {(Array.isArray(playlists) ? playlists : []).map(pl => (
          <div key={pl.id} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <SidebarItem icon={<Music2 />} label={pl.name} active={activePlaylist?.id === pl.id} onClick={() => fetchPlaylistSongs(pl)} />
            <span onClick={async () => {
              if (confirm(`Ta bort ${pl.name}?`)) {
                await fetch(`${API_BASE}/api/playlists/${pl.id}`, {
                  method: 'DELETE',
                  headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchPlaylists();
              }
            }} style={{ cursor: 'pointer', fontSize: '12px', color: 'var(--text-muted)', padding: '10px 4px', transition: 'color 0.2s' }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'red'} onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}>
              <X size={15} />
            </span>
          </div>
        ))}
        <SidebarItem icon={<Heart />} label="Likade låtar" />
      </div>
      <ThemeSwitcher currentTheme={theme} setTheme={setTheme} />
      <div className="logout-btn" onClick={handleLogout}>
        <LogOut /> Logga ut ({username})
      </div>
    </div>
  );
}
